// components/FormRenderer.jsx
import React, { useEffect, useRef } from "react";
import { Form } from "@formio/react";

// This ref will hold the form instance
let formInstanceRef = null;

// Exposed function to be used outside the component
export const handleExternalSubmit = () => {
  console.log("External submit triggered");
  if (formInstanceRef) {
    formInstanceRef.submit();
  } else {
    console.warn("Form is not initialized yet.");
  }
};

const transformFormJson = (formJson) => {
  // Recursively remove all submit buttons and replace textareas with rich text
  const transformComponents = (components) => {
    return (
      components
        // .filter(
        //   (component) =>
        //     !(component.type === "button" && component.action === "submit")
        // )
        .map((component) => {
          // Replace textarea with rich text editor
          if (component.type === "textarea") {
            component = {
              ...component,
              wysiwyg: true,
              editor: "ckeditor",
            };
          }

          // Hide specific fields
          if (["userId", "formStage", "submissionStage"].includes(component.key)) {
            component = {
              ...component,
              hidden: false, // allow submission, but not Form.io hiding
              defaultValue: component.defaultValue || "",
              customClass: "visually-hidden", // hide via CSS
            };
          }

          // Recursively handle nested components
          if (component.components) {
            return {
              ...component,
              components: transformComponents(component.components),
            };
          }

          if (component.columns) {
            return {
              ...component,
              columns: component.columns.map((col) => ({
                ...col,
                components: transformComponents(col.components),
              })),
            };
          }

          return component;
        })
    );
  };

  formJson.components = transformComponents(formJson.components);
  return formJson;
};

const FormRenderer = ({ submissionData, formJson, onSubmit, isCreating, className }) => {
  // Clone submissionData so we don’t mutate props
  const transformedSubmission = { ...submissionData };

  // Only when creating → overwrite ref
  if (isCreating && formJson?.tags?.[1]) {
    transformedSubmission.ref = formJson.tags[1];
  }

  return (
    <div className={className}>
      <Form
        form={transformFormJson(formJson)}
        submission={{ data: transformedSubmission }}
        onSubmit={(submission) => onSubmit(submission.data)}
      />
    </div>
  );
};

export default FormRenderer;
